import { MonthlyCheckDto } from "@/pages/monthly-inspection";
import { ApiResponse, CommonParams } from "@/types";
import { createQueryString } from "@/utils/filterParams";
import api from "./api";

const monthlyCheckService = {
  getMonthlyChecks: async (
    params: CommonParams<{}>
  ): Promise<ApiResponse<MonthlyCheckDto[]>> => {
    const paramsValue = {
      page: 1,
      isPagination: 1,
      limit: 10,
      orderBy: "id",
      order: "DESC",
      withDeleted: 0,
      ...params,
    };
    const paramsString = createQueryString(paramsValue);
    const response = await api.get(`/store/my-inspections?${paramsString}`);
    const responseData = response.data.data;
    
    // Ensure data is always an array
    if (!responseData || !responseData.data) {
      return {
        data: [],
        status: response.data.status || 200,
        pagination: responseData?.pagination || {
          page: 1,
          pageSize: 10,
          total: 0,
          totalPages: 0,
        },
      };
    }
    
    return {
      ...responseData,
      data: Array.isArray(responseData.data) ? responseData.data : [],
    };
  },

  answerMonthlyCheck: async (data: {
    result_id: number;
    answers: boolean[];
  }): Promise<ApiResponse<null>> => {
    const response = await api.post(
      `/monthly-inspections/store/submit-answer`,
      data
    );
    return response.data;
  },

  getMonthlyCheckStoreResults: async (
    params: CommonParams<{
      status?: string;
      search?: string;
      series?: string;
      answer_status?: string;
      verification_status?: string;
      answer_date_from?: string;
      answer_date_to?: string;
      applicable_month?: number;
      year?: number;
    }>,
  ): Promise<ApiResponse<any[]>> => {
    const paramsString = createQueryString({
      orderBy: "id",
      order: "DESC",
      ...params,
    });
    const response = await api.get(
      `/monthly-inspections/store-results?${paramsString}`,
    );
    const result = response.data?.data ?? response.data;
    const list = Array.isArray(result?.data)
      ? result.data
      : Array.isArray(result)
        ? result
        : [];

    return {
      data: list,
      status: response.data?.statusCode ?? response.status,
      pagination: result?.pagination ?? response.data?.pagination,
    };
  },

  getMonthlyCheckStoreResultDetail: async (id: number) => {
    const response = await api.get(`/monthly-inspections/store-results/${id}`);
    return response.data.data;
  },

  exportMonthlyInspectionsCsv: async (params: {
    search?: string;
    status?: string;
    series?: string;
    answer_status?: string;
    verification_status?: string;
    answer_date_from?: string;
    answer_date_to?: string;
    applicable_month?: number;
    year?: number;
    theme?: string;
  }): Promise<Blob> => {
    const paramsString = createQueryString(params);
    const response = await api.get(
      `/monthly-inspections/export/csv?${paramsString}`,
      {
        responseType: "blob",
        headers: {
          Accept: "text/csv, application/csv, application/octet-stream",
        },
      },
    );

    return response.data;
  },
};

export { monthlyCheckService };
